export function directionsUrl(venue, origin = null) {
  const destination = venue.lat != null && venue.lng != null
    ? `${venue.lat},${venue.lng}`
    : `${venue.name || "Venue"} ${venue.address || ""}`.trim();
  const params = new URLSearchParams({ api: "1", destination, travelmode: "driving" });
  if (origin) params.set("origin", `${origin.lat},${origin.lng}`);
  return `https://www.google.com/maps/dir/?${params.toString()}`;
}
